import React, { useState } from 'react';
import { SlidingBarComponent } from 'src/common-ui/switch-bar/sliding-bar.component';
export const TabsComponent = ({ tabs }) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const values = tabs.map((tab, index) => {
        return {
            value: index,
            label: tab.title,
            skipLabelTransaction: tab.skipTranslation,
        };
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(SlidingBarComponent, { onChange: setSelectedTab, selectedValue: selectedTab, values: values, id: "tabs" }),
        tabs.map((tab, index) => (React.createElement("div", { key: `tab-${tab.title}-${index}`, className: `tab-container ${selectedTab === index ? 'selected' : ''}` }, tab.content)))));
};
